module.exports = __webpack_public_path__ + "static/media/im-rahmen3.01fa1df4.png";